import { exploreSchemaItemList } from '@/templates/Landing/seoLandings/exploreSchema';
import { ENV } from '@/constants';

export const schemaObject_AiClayFilter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-clay-filter',
			name: 'Clay AI Generator – Claymation Filter & Clay Art Maker | Lift',
			description:
				"Transform photos into claymation art instantly with Lift's AI clay filter. Upload any image and get playful clay-style results in seconds. No watermark.",
			url: 'https://liftapp.ai/ai-clay-filter',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-clay-filter#product' },
				{ '@id': 'https://liftapp.ai/ai-clay-filter#howto' },
				{ '@id': 'https://liftapp.ai/ai-clay-filter#benefits' },
				{ '@id': 'https://liftapp.ai/ai-clay-filter#faq' },
				{ '@id': 'https://liftapp.ai/ai-clay-filter#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-clay-filter#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-clay-filter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-clay-filter#product',
			name: 'AI Clay Generator Online',
			description:
				"Transform photos into claymation art instantly with Lift's AI clay filter. Upload any image and get playful clay-style results in seconds. No watermark.",
			url: 'https://liftapp.ai/ai-clay-filter',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-clay-filter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: '✨ AI applies the clay effect',
					text: 'Watch as your photo transforms into smooth, sculpted claymation-style art with realistic textures and playful details',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-clay-filter#benefits',
			name: 'Who can benefit from Clay AI Generator?',
			description:
				"Lift's AI Clay Generator is useful for creators, social media users, parents, marketing teams, and content creators who want to transform photos into playful claymation-style art.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for creators who love nostalgic, stop-motion aesthetics',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Social media users can create thumb-stopping posts with unique clay-style visuals',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Parents and kids can turn family photos into fun, playful clay characters',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Marketing teams can generate memorable brand content with a handcrafted feel',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Content creators can add whimsical, tactile visuals that stand out in feeds',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'AI Clay Generator by Lift',
				description:
					'Example of how Lift AI Clay Generator transforms photos into playful claymation-style art.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-clay-filter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Clay AI Generator?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Clay AI Generator is a online tool that transforms your photos into claymation-style art — perfect for social media, creative projects, or just for fun. Get that iconic clay model look in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Clay AI Generator work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo and applies a claymation-style filter that mimics the look of hand-sculpted clay models. It adds smooth textures, soft shadows, and playful proportions — all automatically, with no manual editing required.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I make any photo into claymation?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift's clay filter works with portraits, pets, objects, landscapes, and more. The AI adapts to your image and applies the clay effect while preserving recognizable features and details.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without a watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, or personal use.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-clay-filter#why-lift',
			name: "Why Lift's AI Clay Generator stands out",
			description:
				"Lift's Clay AI Generator combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Why use Lift AI Clay Generator',
				description:
					"Comparison of Lift's AI Clay Generator benefits — high-quality results, intelligent rendering, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-clay-filter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-clay-filter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Clay AI Generator',
					item: 'https://liftapp.ai/ai-clay-filter',
				},
			],
		},
	],
};
